module.exports = __webpack_public_path__ + "img/closeButton.81de4b01.svg";